import { useLocation } from 'react-router-dom'
import { useMemo } from 'react'
import { ARTICLE_VIEW_PARAM } from 'components/ArticleViewSelect/types'
import { ArticleView } from 'types'
import { LocationDescriptorObject } from 'history'

interface Props {
  articleView?: ArticleView
}

export const useArticleViewLink = (props?: Props): { to: LocationDescriptorObject } => {
  const location = useLocation()
  const { articleView = ArticleView.Editing } = props || { articleView: ArticleView.Editing }

  const search = useMemo(() => {
    const searchParams = new URLSearchParams(location.search)
    searchParams.set(ARTICLE_VIEW_PARAM, articleView)
    return searchParams.toString()
  }, [articleView, location.search])

  return {
    to: {
      ...location,
      search,
    },
  }
}
